'use client';

import { Select } from '../Select/Select';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { orderSearchParams } from '@/utils/search/params';

const ORDER_VALUES = [
  { value: 'best-match', key: 'bestMatch' },
  { value: 'newest', key: 'newest' },
  { value: 'oldest', key: 'oldest' },
  { value: 'trending', key: 'trending' },
  { value: 'downloads-all-time', key: 'downloadsAllTime' },
] as const;

const getDefaultOption = (order: string | null, query: string) => {
  // if no order and no search query return trending
  if (!order && !query) return 'trending';
  // if (!order && !query) return 'newest';
  // if no order and search query return best-match
  if (!order) return 'best-match';
  // if order and no search query return order
  return order;
};

const SearchOrder = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const t = useTranslations('search.order');
  const order = searchParams.get('order');
  const query = searchParams.get('q') || '';
  const page = searchParams.get('page') || '1';

  const orderOptions = ORDER_VALUES.map((opt) => ({ value: opt.value, label: t(opt.key) }));
  const getOrderOptions = (q: string) =>
    q ? orderOptions : orderOptions.filter((opt) => opt.value !== 'best-match');

  const onChange = (value: string) => {
    const params = new URLSearchParams(searchParams);
    if (query) {
      if (value !== 'best-match') params.set('order', value);
      else params.delete('order');
    } else {
      if (value !== 'trending') params.set('order', value);
      // if (value !== 'newest') params.set('order', value);
      else params.delete('order');
    }
    if (page !== '1') {
      // remove the page param
      params.delete('page');
    }
    router.push(`${pathname}?${orderSearchParams(params)}`, { scroll: false });
  };

  return (
    <div className="relative z-20 flex flex-row w-full md:w-[296px] min-w-0 md:shrink-0">
      <Select
        defaultOption={getDefaultOption(order, query)}
        options={getOrderOptions(query)}
        onChange={(val) => onChange(val as string)}
        value={getDefaultOption(order, query)}
      />
    </div>
  );
};

export default SearchOrder;
